export const taxes = [
    { value: 'osn', label: 'Общая СН' },
    { value: 'usn_income', label: 'Упрощенная СН (доходы)' },
    { value: 'usn_income_outcome', label: 'Упрощенная СН (доходы - расходы)' },
    { value: 'patent', label: 'Патентная СН' },
    { value: 'envd', label: 'Единый налог на вмененный доход' },
    { value: 'esn', label: 'Единый сельхоз налог' }
];

export const ffd_versions = [
    { value: '1.05', label: '1.05' },
    { value: '1.2', label: '1.2' }
];

export const nds = [
    { value: 'none', label: 'Без НДС' },
    { value: 'vat0', label: 'НДС по ставке 0%' },
    { value: 'vat10', label: 'НДС чека по ставке 10%' },
    { value: 'vat18', label: 'НДС чека по ставке 18%' },
    { value: 'vat110', label: 'НДС чека по расчетной ставке 10/110' },
    { value: 'vat118', label: 'НДС чека по расчетной ставке 18/118' },
    { value: 'vat120', label: 'НДС чека по расчетной ставке 20/120' }
];

export const tinkoffDefaults = {
    terminal_key: '',
    terminal_password: '',
    taxation_type: 'osn',
    ffd: '1.2',
    vat: 'none',
};
